import { NodeModel } from "../_model/NodeModel";
import { DecorationBoiler } from "../boiler/decorationBoiler";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Boiler extends NodeModel {
    constructor() {
        super("Boiler");

        this.type = new Types().Boiler;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 200;
        this.width = 210;
        this.operationSelected = '';
        this.srcImg = require("@/assets/Fluxogramas/caldeira.png");
        this.data = [new Properties({...this })];
        this.CurrentTempAr = null
        this.currentCapacityAux = null
        this.jokerCaption = [];

        this.decorate = async function(callback) {
            this.decorator = new DecorationBoiler();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new Boiler()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.readOnly = this.readOnly
            cloned.decorator = null
            cloned.CurrentTempAr = this.CurrentTempAr
            cloned.currentCapacityAux = this.currentCapacityAux
            cloned.expressionVisible = this.expressionVisible
            cloned.data = this.data.map(d => d.clone());
            cloned.jokerCaption = this.jokerCaption

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.data = node.data.map(d => new Properties({...d }));
            this.CurrentTempAr = node.CurrentTempAr
            this.currentCapacityAux = node.currentCapacityAux
            this.jokerCaption = node.jokerCaption
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs
            }

            if (node.CurrentTempAr) {
                this.CurrentTempAr = node.CurrentTempAr;
            }

            if (node.currentCapacityAux) {
                this.currentCapacityAux = node.currentCapacityAux;
            }
            
            this.expressionVisible = node.expressionVisible;
            this.jokerCaption = node.jokerCaption;
        }

        // Para caso o nó tenha connections.
        // this.removeConnection = (connectionId) => {
        //   this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
        // }
    }
}

export { Boiler };